import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource';
import 'vant/lib/index.css';
import './assets/styles/reset.css';
import './assets/styles/border.css';
import './assets/styles/iconfont.css';
import './assets/styles/style.css';
import './assets/styles/iconfont.js';

import { NavBar,Toast,Image,Lazyload,Panel,Button,Field,CellGroup,Icon } from 'vant';
Vue.use(NavBar).use(Toast).use(Image).use(Lazyload).use(Panel).use(Button).use(Field).use(CellGroup).use(Icon);
Vue.use(VueResource);

Vue.config.productionTip = false
var GlobalVar = {URL:'http://yijia.sihandbms.cn/',API:'http://yijia.sihandbms.cn/api.php/',IMG:'http://yijia.sihandbms.cn/upload/',BMKEY:'MFdVZSa9BZzUp8H4UlfYNsKbH60cRas7'};
Vue.prototype.GLOBAL = GlobalVar

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
